/**
 * PUT `admin/clients/:id/ai-mode` — режим ассистента клиники: выключен,
 * наблюдает (готовит ответы, пациенту не пишет), черновики, отвечает сам.
 *
 * Текущий режим читается из карточки клиента (`ClientDetail.aiMode`) —
 * экран больше не помнит «что поставили в этой сессии».
 */

import {apiEnabled, http} from '@services/utils';

import type {AiMode} from '../types';

export type SetAiModeInput = {id: string; mode: AiMode};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const setAiMode = async (input: SetAiModeInput): Promise<AiMode> => {
  if (!apiEnabled) {
    await sleep(300);
    return input.mode;
  }
  const res = await http<{mode?: unknown}>(
    `admin/clients/${encodeURIComponent(input.id)}/ai-mode`,
    {method: 'PUT', body: {mode: input.mode}, skipCaseConversion: true},
  );
  const mode = res.mode;
  return mode === 'off' || mode === 'shadow' || mode === 'assisted' || mode === 'auto'
    ? mode
    : input.mode;
};
